import React, { useState } from 'react';
import { FeedbackForm } from './ui';

const Footer = () => {
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);

  return (
    <footer className="mt-8 py-6 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          {/* <div className="text-sm text-gray-600">
            Built with ❤️ by <a href="https://debbyling.github.io/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 hover:underline">Debby</a>.
          </div> */}
          <div className="mt-4 sm:mt-0">
            <FeedbackForm />
          </div>
        </div>
        
        {/* Collapsible Disclaimer Section */}
        <div className="mt-6 text-center">
          <button 
            onClick={() => setIsDisclaimerOpen(!isDisclaimerOpen)}
            className="text-xs text-gray-500 hover:text-gray-700 hover:underline focus:outline-none flex items-center justify-center mx-auto"
          >
            <span>Disclaimer</span>
            <svg 
              className={`w-3 h-3 ml-1 transition-transform duration-200 ${isDisclaimerOpen ? 'transform rotate-180' : ''}`} 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {isDisclaimerOpen && (
            <div className="mt-2 text-xs text-gray-500 max-w-2xl mx-auto transition-all duration-300 ease-in-out">
              This calculator is for educational/convenience purposes only. Use at your own risk. Results are general estimates, not financial advice. Verify rates with banks and consult a financial advisor for personalized guidance. We assume no liability for losses resulting from decisions made using this tool.
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 